export class PageNotFoundError extends Error {
  public static readonly code = 404;
}
